/**
 * Kabuk seçimi (Faz 0): yeni kabuk varsayılan; app_config.crm_ui_v2 =
 * 'false' ise herkes eski iki katmanlı kabuğa döner (acil fren).
 */
import { Suspense, lazy, useEffect, type PropsWithChildren } from "react";
import { useLocation } from "react-router";
import { ThemedLayout } from "@refinedev/antd";
import { RefineKbar } from "@refinedev/kbar";
import "./shell.css";
import "../ui/ui.css";
import { Header } from "../components/header";
import { AppSider } from "../components/app-sider";
import { SiderNav } from "./sider-nav";
import { TopBar } from "./top-bar";
import { SectionTabs } from "./section-tabs";
import { CommandPalette } from "./command-palette";
import { applyLabsParam, useShellV2 } from "./flags";
import { usePaymentWizardState } from "../pages/finans/payment-store";

const PaymentWizardHost = lazy(() => import("../pages/finans/payment-host"));

/** "Ödeme al" sihirbazı: ilk açılışta yüklenir, sonra kabukta kalır. */
const PaymentHostSlot = () => {
  const { loaded } = usePaymentWizardState();
  return loaded ? (
    <Suspense fallback={null}>
      <PaymentWizardHost />
    </Suspense>
  ) : null;
};

const LegacyHeader = () => <Header sticky />;

export const ShellLayout = ({ children }: PropsWithChildren) => {
  const v2 = useShellV2();
  const { search } = useLocation();

  useEffect(() => {
    applyLabsParam(search);
  }, [search]);

  if (!v2) {
    return (
      <>
        <ThemedLayout Header={LegacyHeader} Sider={AppSider}>
          {children}
        </ThemedLayout>
        <PaymentHostSlot />
      </>
    );
  }
  return (
    <>
      <ThemedLayout Header={TopBar} Sider={SiderNav}>
        <SectionTabs />
        {children}
      </ThemedLayout>
      <CommandPalette />
      <PaymentHostSlot />
    </>
  );
};

/** Eski kabukta Refine'ın ⌘K'sı; yeni kabukta kendi paletimiz kullanılır. */
export const LegacyKbar = () => {
  const v2 = useShellV2();
  return v2 ? null : <RefineKbar />;
};
